export const HOME_PAGE_TEXT = {
  HOME_PAGE: 'Dashboard',
  MANAGEMENT: 'Management',
};
